<template>
  <el-dialog
    :visible="value"
    width="520px"
    custom-class="manual-verification-code-modal"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="close"
  >
    <div class="manual-code-body">
      <div class="manual-code-title">
        {{ $t("verification.manualTitle") }}
      </div>

      <div class="manual-code-step">
        <div class="manual-code-step-title">
          {{ $t("verification.manualStep1Title") }}
        </div>
        <div class="manual-code-step-description">
          {{ $t("verification.manualStep1Description") }}
        </div>
      </div>

      <div class="manual-code-step">
        <div class="manual-code-step-title">
          {{ $t("verification.manualStep2Title") }}
        </div>
        <div class="manual-code-step-description">
          {{ $t("verification.manualStep2Description") }}
        </div>
      </div>
    </div>

    <button type="button" class="manual-code-confirm" @click="close">
      {{ $t("verification.manualConfirm") }}
    </button>
  </el-dialog>
</template>

<script>
export default {
  name: "ManualVerificationCodeModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style>
.manual-verification-code-modal {
  border-radius: 16px !important;
  overflow: hidden;
}

.manual-verification-code-modal .el-dialog__header {
  display: none;
}

.manual-verification-code-modal .el-dialog__body {
  color: #000927;
  padding: 0 !important;
}

.manual-verification-code-modal .manual-code-body {
  padding: 30px 26px 26px;
}

.manual-verification-code-modal .manual-code-title {
  font-family: Noto Sans, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 22px;
}

.manual-verification-code-modal .manual-code-step + .manual-code-step {
  margin-top: 20px;
}

.manual-verification-code-modal .manual-code-step-title {
  font-family: Noto Sans, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
}

.manual-verification-code-modal .manual-code-step-description {
  color: #45484d;
  font-family: Noto Sans, sans-serif;
  font-size: 14px;
  line-height: 22px;
  margin-top: 4px;
}

.manual-verification-code-modal .manual-code-confirm {
  appearance: none;
  background: transparent;
  border: 0;
  border-top: 1px solid #e1e3e6;
  color: #00eec3;
  cursor: pointer;
  font-family: Noto Sans, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  margin: 0;
  padding: 16px 0;
  width: 100%;
}

@media screen and (max-width: 600px) {
  .manual-verification-code-modal {
    margin-top: 15vh !important;
    max-width: 400px;
    width: calc(100% - 40px) !important;
  }

  .manual-verification-code-modal .manual-code-body {
    padding: 26px 22px 22px;
  }

  .manual-verification-code-modal .manual-code-title {
    font-size: 18px;
    line-height: 27px;
    margin-bottom: 18px;
  }

  .manual-verification-code-modal .manual-code-step + .manual-code-step {
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ManualVerificationCodeModal.vue